<template lang="pug">
div.ag-custom-cell.ag-cell-date
  div.ag-custom-cell-value {{formattedDate}}
  | &nbsp;&nbsp;
  i.fas.fa-caret-down.ag-row-expand-icon.pull-right(
    v-if='showCaret'
    @click='showDetails'
  )
  div.ag-row-details.ag-menu.ag-menu-date.fade(:style='position', :class='{ "shown": shownDetails }')
    i.ag-row-expand-close.fal.fa-times(@click='showDetails')
    div.ag-row-details-content.ag-filter.ag-filter-date
      ed-datepicker.standalone(v-if='shownDetails' placement='inline' fit @input='edit')
</template>

<script>

import Calendar from '@/core/components/edDatepicker'

export default {
  data() {
    return {
      shownDetails: false,
      formattedDate: null
    }
  },

  computed: {
    position() {
      return {
        width: this.cell.style.width
      }
    },
    showCaret() {
      let editable = this.params.colDef.columnEditable
      return !(this.params.data || {})._disabled && this.formattedDate && editable
    }
  },

  created() {
    //
    if (this.params.value && ~this.params.value.indexOf('Date(')) {
      this.date = this.params.value.split('Date(') && this.params.value.split('Date(')[1].split(')')[0]
      this.date = new Date(+this.date)
      this.formattedDate = Calendar.methods.formatDate(this.date, global.app.$user.sessionSettings.DateAndTimeFormats.DateFormat)
    }

    // already formatted on server-side
    if (~this.params.colDef.field.indexOf('Formatted')) {
      this.formattedDate = this.params.value
    }

    this.colApi = this.params.api.columnController

    this.cell = this.params.eGridCell
    this.cell.style.overflow = 'visible'

    this.params.editMode = true
    this.cell.className = this.cell.className.replace(' ag-cell-date-expanded', '') + ' ag-cell-date-expanded'
  },

  methods: {
    showDetails() {
      this.shownDetails = !this.shownDetails
    },

    edit(v) {
      const formattedDate = Calendar.methods.formatDate(v, global.app.$user.sessionSettings.DateAndTimeFormats.DateFormat)
      const date = Calendar.methods.formatDate(v, 'YYYY-MM-DD')
      const ts = new Date(date).getTime()

      this.params.setValue(`/Date(${ts})/`)
      this.formattedDate = formattedDate
    },

    refresh() {
      //
      this.shownDetails = false
    }
  }
}

</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

.ag-custom-cell {
  display: inline-block;
  &.ag-cell-date {
    min-width: 85%;
  }

  input.form-control[search] {
    //width: 90%;
  }

  .list.edit {
    margin: 0;

    .form-group {
      margin: 0;
    }

    input[type="checkbox"], .check-mask {
      display: none;
    }
  }
}

.ag-custom-cell-value {
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 85%;
}

.ag-cell-date .ag-row-expand-icon {
  font-size: $font-size-base;
  vertical-align: middle;
  cursor: pointer;
  @include theme {
  color: v(border);
  }
}
.ag-row-expand-close {
  font-size: $font-size-base-lg;
  vertical-align: middle;
  cursor: pointer;
  @include theme {
  color: v(ink);
  }
  position: absolute;
  left: -10px;

  .ag-cell-date & {
    //display: none;
    left: auto;
    right: 13px;
    top: 8px;
    z-index: 1001;
  }
}

.ag-row-details {
  background: #fff;
  @include theme {
  border-bottom: 1px solid v(background);
  }
  position: absolute;
  top: 30px;
  left: auto;
  width: auto;
  height: 90px;
  margin: -1px;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: -1;
  padding: 20px 30px;

  .ag-cell-date & {
    left: 0;
    padding: 0;
    height: auto;
  }

  .ag-row-details-content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .content.grid .ag-fresh &.ag-menu {
    @include theme {
    border-color: v(background-light);
    }
    border-top: none;
    margin-top: -31px;
    margin-left: -2px;
    z-index: -1;
  }
  .content.grid .ag-fresh &.ag-menu.shown.ag-menu-date,
  .content.grid .ag-fresh &.ag-menu.shown.ag-menu-date .ag-filter.ag-filter-date {
    opacity: 1;
    z-index: 999;
    padding: 5px 0 0 1px;
  }
}

.ag-row-expanded {
  /*@include theme {
  background: lighten(v(secondary-04), 8%);
  }*/
}
//.theme .ag-cell-expanded,
.ag-cell-focus.ag-cell-date-expanded {
  border-color: transparent;
  @include theme {
  border-right-color: v(background-light);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Grid/cells/date.vue